import { z } from 'zod';
/**
 * Flow — connect the dots.
 *
 * A grid holds pairs of coloured dots. Draw a path between each pair so that
 * every cell is filled and no two paths cross. Solved when all pairs are joined
 * and the board is full.
 *
 * The client owns the drawing UX (drag from a dot); it sends the full path for a
 * colour whenever the player finishes or clears one. The server is authoritative
 * on what "solved" means.
 */
export const FLOW_PALETTE = ['#ff4d4d', '#22e0ff', '#a6ff2e', '#ffb020', '#8b7dff', '#ff6ad5', '#ffffff', '#4d7dff'];
/**
 * Set (or clear) the path for one colour. The path is a list of flat cell
 * indices from one endpoint toward the other; an empty list clears it.
 */
export const FlowSetPathEvent = z.object({
    type: z.literal('path'),
    color: z.number().int().min(0).max(FLOW_PALETTE.length - 1),
    cells: z.array(z.number().int().min(0).max(255)).max(256),
});
export const FlowEvent = z.discriminatedUnion('type', [FlowSetPathEvent]);
//# sourceMappingURL=flow.js.map